import React, { useState } from "react";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa6";
import { motion, AnimatePresence } from "framer-motion";
import { stakeData } from "../utils/data";
import metaWalet_img from "../../assets/metaWalet_img.webp";
import walletConnect_img from "../../assets/walletConnect_img.webp";
import creditCard_img from "../../assets/creditCard_img.webp";
import debitCard_img from "../../assets/debitCard_img.webp";
import credt_card_img from "../../assets/credt_card_img.webp";
import success_popup_img from "../../assets/success_popup_img.webp";
import { IoIosCloseCircle } from "react-icons/io";

const tabs = [
  { id: "Overview", label: "Overview" },
  { id: "Performance", label: "Performance" },
  { id: "Compliance", label: "Compliance" },
  { id: "Documents", label: "Documents" },
];

const coinOptions = [
  {
    label: "Flexible ",
  },
  {
    label: "3 Months",
  },
  {
    label: "6 Months",
  },
  {
    label: "9 Months",
  },
];

const StakeDetails = () => {
  const [selectedTab, setSelectedTab] = useState(tabs[0]);
  const [selected, setSelected] = useState(coinOptions[0]);

  return (
    <>
      <Header />

      <main className="main_flx">
        <Sidebar />

        <div className="right_wrap pb-4">
          <Link to="/stake" className="st_back_btn">
            <FaArrowLeft />
            Back
          </Link>
          <h4 className="subheading">Stake Details</h4>

          <div className="st_detail_box">
            <div className="row g-4">
              <div className="col-xl-8">
                <div className="st_detail_box_lft">
                  <h3 className="st_dt_title">
                    <span>
                      <img
                        src={
                          new URL(
                            "../../assets/mrkt_card_icontop7.webp",
                            import.meta.url
                          )
                        }
                        alt=""
                      />
                    </span>
                    Harbor Heights
                  </h3>
                  <img
                    src={
                      new URL(
                        "../../assets/market_card_img7.webp",
                        import.meta.url
                      )
                    }
                    alt=""
                  />
                  <h6>Harbor Heights</h6>
                  <p>Waterfront Properties Fund</p>

                  <span>
                    Tokenized luxury condos and villas near premium US
                    waterfront locations.
                  </span>

                  <div className="st_detail_grid">
                    <div className="st_detail_grid_box">
                      <span>Asset Class</span>
                      <h6>Private Equity</h6>
                    </div>
                    <div className="st_detail_grid_box">
                      <span>APY</span>
                      <h6>10.00% p.a.</h6>
                    </div>
                    <div className="st_detail_grid_box">
                      <span>Lock Period</span>
                      <h6>Flexible</h6>
                    </div>
                    <div className="st_detail_grid_box">
                      <span>Min Stake</span>
                      <h6>USD 3,000</h6>
                    </div>
                  </div>

                  <div className="st_tb_btn_wrap">
                    {/* <motion.div
                      className="tab-bg absolute top-0 bottom-0"
                      layoutId="tabBackground"
                      transition={{
                        type: "spring",
                        stiffness: 500,
                        damping: 30,
                      }}
                      style={{
                        width: `${100 / tabs.length}%`,
                        left: `${
                          tabs.findIndex((t) => t.id === selectedTab.id) *
                          (100 / tabs.length)
                        }%`,
                      }}
                    /> */}

                    {tabs.map((tab) => (
                      <button
                        key={tab.id}
                        className={`st_tb_btn ${
                          selectedTab.id === tab.id ? "active" : ""
                        }`}
                        onClick={() => setSelectedTab(tab)}
                      >
                        <span>{tab.label}</span>
                      </button>
                    ))}
                  </div>

                  <div className="st_tb_content">
                    {selectedTab.id === "Overview" ? (
                      <>
                        <h4 className="ov_title">Overview</h4>
                        <p className="ov_txt">
                          Harbor Heights is a premier tokenized real estate fund
                          centered on luxury waterfront developments across the
                          US. By staking Harbor Heights tokens, investors unlock
                          annual yields of 9–11%, backed by consistent rental
                          income and asset-backed security. The fund offers
                          flexible lock periods ranging from 3 to 12 months,
                          allowing participants to tailor their staking
                          strategy. With over $40M total value locked and
                          10,000+ active stakers, Harbor Heights provides both
                          stability and competitive returns, combining the
                          benefits of real estate with the efficiency of
                          blockchain-powered staking.
                        </p>
                      </>
                    ) : selectedTab.id === "Performance" ? (
                      <>
                        <div className="performance_graph">
                          <img
                            src={
                              new URL(
                                "../../assets/performance_graph.webp",
                                import.meta.url
                              )
                            }
                            alt=""
                            className="w-100"
                          />
                          dksjf
                        </div>
                      </>
                    ) : selectedTab.id === "Compliance" ? (
                      <>
                        {" "}
                        <h4 className="ov_title">Legal & Compliance</h4>
                        <div className="st_cmp_flex_wrap">
                          <div className="st_cmp_flex">
                            <span>KYC/AML Note</span>
                            <p>
                              All investors must complete KYC/AML verification
                              per US SEC & FinCEN guidelines.
                            </p>
                          </div>
                          <div className="st_cmp_flex">
                            <span>Custodian Details</span>
                            <p>SecureTrust Custody Services</p>
                          </div>
                          <div className="st_cmp_flex">
                            <span>Onchain Audit</span>
                            <Link className="st_cmp_link">
                              View on Etherscan
                            </Link>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <h4 className="ov_title">Documents</h4>
                        <Link className="st_doc_link">
                          Whitepaper / Investment Thesis
                        </Link>
                        <Link className="st_doc_link">
                          Property Valuation Report
                        </Link>
                        <Link className="st_doc_link">Legal Disclosures</Link>
                      </>
                    )}
                  </div>

                  <div className="st_btm_btn_wrap">
                    <button className="st_btm_btn_lft">Cancel</button>
                    <button className="st_btm_btn_rgt">Stake Now</button>
                  </div>
                </div>
              </div>
              <div className="col-xl-4">
                <div className="st_detail_box_rgt">
                  <img
                    src={
                      new URL("../../assets/staking_icon.webp", import.meta.url)
                    }
                    alt=""
                  />
                  <p>
                    Stake Now in Harbor Heights{" "}
                    <span>
                      <img
                        src={
                          new URL(
                            "../../assets/mrkt_card_icontop7.webp",
                            import.meta.url
                          )
                        }
                        alt=""
                      />
                    </span>{" "}
                  </p>

                  <form
                    className="staking_form"
                    onSubmit={(e) => e.preventDefault()}
                  >
                    <div className="staking_form_group">
                      <label htmlFor="lock-period">Lock Period</label>
                      <div className="dropdown swap_dropdown">
                        <button
                          className="dropdown-toggle swap_dropdown_toggle"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span className="swp_lft_flx">{selected.label}</span>
                        </button>
                        <ul className="dropdown-menu swp_dropdown_menu">
                          {coinOptions.map((opt) => (
                            <li key={opt.label}>
                              <button
                                className="dropdown-item swp_dropdown_item"
                                onClick={() => setSelected(opt)}
                              >
                                {opt.label}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    <div className="staking_form_group mt-3">
                      <label htmlFor="stake-amount">
                        Enter Amount to Stake
                      </label>
                      <input
                        type="number"
                        id="stake-amount"
                        placeholder="2000"
                      />
                    </div>
                    <span className="st_fm_tkn">
                      Available: 2,350 UB Tokens
                    </span>
                    <p className="st_fm_est">
                      Est. Rewards: +225 UB (~$225) in 90 days
                    </p>
                    <button
                      className="stake_form_btn"
                      // data-bs-toggle="modal"
                      // data-bs-target="#exampleModal"
                      data-bs-toggle="modal"
                      data-bs-target="#confirmInvest"
                    >
                      Confirm Stake
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <h4 className="dsh_subtitle mt-4 mt-sm-5">More Assets</h4>

          <div className="dsh_inv_grid mt-4">
            {stakeData.map((item) => (
              <div key={item.id} className="dsh_inv_card market_card">
                <div className="dsh_inv_head">
                  <div className="dsh_inv_top mrkt_top_title">
                    <div className="mrkt_top_content">
                      <img
                        className="img_div"
                        src={item.logoImg}
                        alt={item.title}
                      />
                      <h6>{item.cardTitle}</h6>
                    </div>
                  </div>
                  <img src={item.cardImg} alt={item.title} />
                  <div className="mrkt_main_cd_tlt mx-0">
                    <h3>{item.cardTitle}</h3>
                    <h5>{item.cardSubTitle}</h5>
                    <p>{item.description}</p>
                  </div>

                  <div className="dsh_inv_card_cnt">
                    <div className="dsh_inv_cd_flx">
                      {item.details.slice(0, 2).map((d, i) => (
                        <div key={i} className="dsh_inv_cd_lft">
                          <span>{d.label}</span>
                          <h4>{d.value}</h4>
                        </div>
                      ))}
                    </div>
                    <div className="dsh_inv_cd_flx mt-4">
                      {item.details.slice(2, 4).map((d, i) => (
                        <div key={i} className="dsh_inv_cd_lft">
                          <span>{d.label}</span>
                          <h4>{d.value}</h4>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <button className="dsh_inv_btn st_bx_btn">
                  <Link to={"/stake-details"}>{item.buttonText}</Link>
                </button>
              </div>
            ))}
          </div>
        </div>
      </main>

      {/* MODAL POPUPS */}
      <div
        class="modal fade confm_invst_popup common_popup_main"
        id="confirmInvest"
        tabindex="-1"
        aria-labelledby="confirmInvestLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="confirmInvestLabel">
                Select Your Payment Method
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {/* <IoClose /> */}
                <IoIosCloseCircle />
              </button>
            </div>
            <div class="modal-body">
              <div className="wallet_wrp">
                <h5>Private Wallet</h5>
                <ul>
                  <li>
                    <div>
                      <img src={metaWalet_img} alt="metaWalet_img" />
                      <h6>Meta Wallet</h6>
                    </div>
                  </li>
                  <li>
                    <div>
                      <img src={walletConnect_img} alt="walletConnect_img" />
                      <h6>Wallect Connect</h6>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="wallet_wrp card_wallet_wrp">
                <h5>On Ramp</h5>
                <ul>
                  <li
                    data-bs-toggle="modal"
                    data-bs-target="#paymentPopup"
                    className="cursor-pointer"
                  >
                    <div>
                      <img src={creditCard_img} alt="creditCard_img" />
                      <h6>Credit Card</h6>
                    </div>
                  </li>
                  <li>
                    <div>
                      <img src={debitCard_img} alt="debitCard_img" />
                      <h6>Debit Card</h6>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade payment_popup common_popup_main "
        id="paymentPopup"
        tabindex="-1"
        aria-labelledby="paymentPopupLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="paymentPopupLabel">
                Card Payment
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {/* <IoClose /> */}
                <IoIosCloseCircle />
              </button>
            </div>
            <div class="modal-body">
              <div className="payment_wrp_popup">
                <div className="payemt_content">
                  <form className="paymnt_popup_form">
                    <div className="field_group">
                      <label>Cardholder Name</label>
                      <input type="text" placeholder="Cardholder Name" />
                    </div>
                    <div className="field_group">
                      <label>Card Number</label>
                      <input type="number" placeholder="0000 0000 0000 0001" />
                    </div>
                    <div className="expry_cvv_wrp">
                      <div className="field_group">
                        <label>Expiration Date</label>
                        <input type="text" placeholder="MM/YY" />
                      </div>
                      <div className="field_group">
                        <label>CVV</label>
                        <input type="number" placeholder="CVV" />
                      </div>
                    </div>
                  </form>

                  <div className="credt_card_img_wrp">
                    <img src={credt_card_img} alt="credt_card_img" />
                  </div>
                </div>

                <div class="form-check paymnt_check_box">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="defaultCheck1"
                  />
                  <label class="form-check-label" for="defaultCheck1">
                    Save this card for faster checkout
                  </label>
                </div>
                <button
                  className="payemnt_fotm_btn"
                  data-bs-toggle="modal"
                  data-bs-target="#successfullyPopup"
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade successfull_popup common_popup_main "
        id="successfullyPopup"
        tabindex="-1"
        aria-labelledby="successfullyPopupLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <img
                className="success_popup_img"
                src={success_popup_img}
                alt="success_popuqp_img"
              />
              <h5 class="modal-title" id="successfullyPopupLabel">
                Successfully staked 2,000 <br /> UB Tokens
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {/* <IoClose /> */}
                <IoIosCloseCircle />
              </button>
            </div>
            <div class="modal-body">
              <div className="successfull_wrp_popup">
                <div className="successfull_content">
                  <ul>
                    <li>
                      <h4>Amount Staked</h4>
                      <span>-</span>
                      <h6>2,000 UB</h6>
                    </li>
                    <li>
                      <h4>Lock Period</h4>
                      <span>-</span>
                      <h6>90 Days</h6>
                    </li>
                    <li>
                      <h4>Est. Rewards</h4>
                      <span>-</span>
                      <h6>225 UB (~$225)</h6>
                    </li>

                    <li>
                      <h4>Transaction Hash</h4>
                      <span>-</span>
                      <h6 className="trnsnumber_id">0x9f3…d81a</h6>
                    </li>
                  </ul>
                </div>
                <div className="succfl_btn_wrp">
                  <button className="successfull_fotm_btn">
                    <Link to={""}>Go to Portfolio</Link>
                  </button>
                  <button className="invset_fotm_btn">Invest more</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StakeDetails;
